import { defineStore } from "pinia";
import Api from "src/utils/api";
import Helper from "src/utils/helper";
import Exception from "src/utils/exception";

export const useEmailTemplatesStore = defineStore("email_templates_store", {
  state: () => ({}),

  actions: {
    async getEmailTemplateById(id) {
      const response = await Api.EmailTemplates.getEmailTemplateById(id);
      return response;
    },

    async sendEmailFromTemplate(
      templateId,
      sendingData,
      attachments = [],
      data = {}
    ) {
      try {
        const emailTemplate = await this.getEmailTemplateById(templateId);

        const fromDefaultSendingData = await Helper.resolveRecipient(
          emailTemplate.data.default_sending_data?.from
        );

        const toDefaultSendingData = await Helper.convertGroupIdsToEmails(
          await Helper.resolveRecipients(
            emailTemplate.data.default_sending_data?.to
          )
        );

        const ccDefaultSendingData = await Helper.convertGroupIdsToEmails(
          await Helper.resolveRecipients(
            emailTemplate.data.default_sending_data?.cc
          )
        );

        const fromSendingData = await Helper.resolveRecipient(
          sendingData?.from
        );
        const toSendingData = await Helper.convertGroupIdsToEmails(
          await Helper.resolveRecipients(sendingData?.to)
        );
        const ccSendingData = await Helper.convertGroupIdsToEmails(
          await Helper.resolveRecipients(sendingData?.cc)
        );

        const combinedSendingData = {
          from: fromSendingData ? fromSendingData : fromDefaultSendingData,
          to: [...(toSendingData || []), ...(toDefaultSendingData || [])],
          cc: [...(ccSendingData || []), ...(ccDefaultSendingData || [])]
        };

        const subject = Helper.findDynamicKeyInExpression(
          emailTemplate.data.template.subject,
          data
        );
        const body = Helper.findDynamicKeyInExpression(
          emailTemplate.data.template.body,
          data
        );

        const emailData = {
          from: combinedSendingData.from,
          to: combinedSendingData.to,
          cc: combinedSendingData.cc,
          subject: subject,
          body: body,
          attachments: attachments
        };

        const response = await Helper.sendEmail(emailData);
        return response;
      } catch (error) {
        Exception.catchException(error);
        return { error: error.message };
      }
    }
  }
});
